import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";  

const LogoService = {
  getAllLogos: async () => {
    try {
      const res = await axios.get(`${ENDPOINT.organizationlogo}/`);
      return res.data;
    } catch (error) {
      console.error("Error fetching all logos", error);
      throw error;
    }
  },

  getLogoById: async (id) => {
    try {
      const res = await axios.get(`${ENDPOINT.organizationlogo}/${id}`);
      return res.data;
    } catch (error) {
      console.error(`Error fetching logo with id ${id}`, error);
      throw error;
    }
  },

  createLogo: async (file) => {
    try {
      const formData = new FormData();
      formData.append("image", file);  // 'image' as per your multer fieldName
      const res = await axios.post(`${ENDPOINT.organizationlogo}/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } catch (error) {
      console.error("Error uploading logo", error);
      throw error;
    }
  },

  updateLogo: async (id, file) => {
    try {
      const formData = new FormData();
      formData.append("image", file);
      const res = await axios.put(`${ENDPOINT.organizationlogo}/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } catch (error) {
      console.error(`Error updating logo with id ${id}`, error);
      throw error;
    }
  },

  deleteLogoById: async (id) => {
    try {
      const res = await axios.delete(`${ENDPOINT.organizationlogo}/${id}`);
      return res.data;
    } catch (error) {
      console.error(`Error deleting logo with id ${id}`, error);
      throw error;
    }
  },

  deleteLogoImageByFilename: async (filename) => {
    try {
      const res = await axios.delete(`${ENDPOINT.organizationlogo}/image/${filename}`);
      return res.data;
    } catch (error) {
      console.error(`Error deleting logo image with filename ${filename}`, error);
      throw error;
    }
  },

  checkImageExists: async (filename) => {
    try {
      const res = await axios.get(`${ENDPOINT.organizationlogo}/image/exists/${filename}`);
      return res.data;
    } catch (error) {
      console.error(`Error checking image existence for ${filename}`, error);
      throw error;
    }
  },

  listImages: async () => {
    try {
      const res = await axios.get(`${ENDPOINT.organizationlogo}/images/list`);
      return res.data;
    } catch (error) {
      console.error("Error listing logo images", error);
      throw error;
    }
  },
};

export default LogoService;





